import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { ReconDashboardPanelComponent } from './recon-dashboard-panel.component'
import { GenericComponentsModule } from '@helios/generic-components'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [ReconDashboardPanelComponent],
  exports: [ReconDashboardPanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReconDashboardModule {}

export { ReconDashboardPanelComponent }
